class Classification {
  static getClassificationBySources(sources) {
    const gradeA = [
      "Essai contrôlé randomisé",
      "Méta-analyse",
      "Guide de pratique clinique",
      "Synthèse clinique",
      "Revue systématique"
    ];
    const gradeB = ["Etude de cohorte", "Etude comparative randomisée"];
    const gradeC = ["Etude de cas", "Etude retrospective", "Série de cas"];

    let result = "AE";
    for (const source of sources) {
      if (gradeA.includes(source.design)) {
        return "A";
      }

      if (gradeB.includes(source.design)) {
        result = "B";
      } else if (gradeC.includes(source.design) && result != "B") {
        result = "C";
      }
    }

    return result;
  }
}
export default Classification;
